/**
 * Normalize an exercise name into a stable key for cross-plan lookups
 * (e.g. "most recent note across plans"). Lowercase, trim, collapse internal
 * whitespace, and strip everything that is not a word char or space.
 *
 * Known limitation (Phase 0): differently-worded names for the same movement
 * (e.g. imported plans) will not match. Accepted for this iteration.
 */
export function normalizeExerciseKey(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^\w\s]/g, '')   // strip punctuation first
    .replace(/\s+/g, ' ')      // then collapse any resulting whitespace
    .trim()
}
